const base_url = process.env.NODE_ENV == 'production' ? 'https://www.picpoti.com/' : 'https://localhost:31313/'
module.exports = base_url
